import { carousel } from "../js/main";

export function pipeChainLogos() {
  document.querySelectorAll(".pipechain-logos__wrapper").forEach((el) => {
    carousel(
      el,
      el.querySelectorAll(".pipechain-logos__logo"),
      [2, 3, 4, 5],
      () => {},
      true
    );
  });
}
